import { edit as editIcon, plantPower as powerIcon } from '@assets'
import { useEffect, useMemo, useRef } from 'react'

const ImagePicker = ({ value, clearImg, onChange }) => {
  const inputFile = useRef(null)
  const editImg = () => inputFile.current.click()

  const previewUrl = useMemo(() => {
    if (value instanceof File) {
      return URL.createObjectURL(value)
    }
    return null
  }, [value])

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl)
      }
    }
  }, [previewUrl])

  const imgSrc = previewUrl || value || powerIcon

  return (
    <div className='flex-2'>
      <div className='box-img'>
        <img className='edit-img' src={editIcon} alt={editIcon} onClick={editImg} />
        <img className='img' src={imgSrc} alt={imgSrc} />
        {value && (
          <div className='cancel' onClick={clearImg}>
            X
          </div>
        )}
      </div>
      <input
        onChange={onChange}
        ref={inputFile}
        className='input-img'
        type='file'
        accept={'image/jpeg, image/png, image/jpg'}
      />
    </div>
  )
}

export default ImagePicker
